// ============================================================================
// DETECÇÃO DE IDIOMA DO NAVEGADOR — FitClutch (funil web)
// ============================================================================
// Mesmo princípio do fitclutch-mobile/src/i18n/detectLanguage.js: lê o
// idioma real (não o país) configurado no navegador da pessoa e escolhe o
// dicionário certo. Se não for um dos 8 suportados, cai no inglês (idioma
// padrão, igual o mobile).
//
// Idiomas com tradução: en (padrão), pt, es, fr, it, de, no, hi.
// ============================================================================

export const SUPPORTED_LANGUAGES = ['en', 'pt', 'es', 'fr', 'it', 'de', 'no', 'hi'];
export const DEFAULT_LANGUAGE = 'en';

export const LOCALE_MAP = {
  en: 'en-US',
  pt: 'pt-BR',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  de: 'de-DE',
  no: 'nb-NO',
  hi: 'hi-IN',
};

// Alguns navegadores reportam variantes pro mesmo idioma (ex: "pt-PT",
// "nb"/"nn" pro norueguês) — normaliza pro código usado nos nomes dos
// arquivos de tradução.
const LANGUAGE_ALIASES = { nb: 'no', nn: 'no' };

export function getBrowserLanguage() {
  try {
    const raw = (navigator.languages?.[0] || navigator.language || '').toLowerCase();
    let code = raw.split('-')[0];
    code = LANGUAGE_ALIASES[code] ?? code;
    if (SUPPORTED_LANGUAGES.includes(code)) return code;
  } catch {
    // ambiente sem `navigator` (ex: SSR) — cai no padrão
  }
  return DEFAULT_LANGUAGE;
}

// Permite forçar um idioma via URL (?lang=pt) — útil pra testar/linkar
// campanhas específicas de um mercado sem depender do navegador da pessoa.
export function getForcedLanguageFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const forced = params.get('lang');
    if (forced && SUPPORTED_LANGUAGES.includes(forced)) return forced;
  } catch {
    // ignore
  }
  return null;
}
